import { render, staticRenderFns } from "./editSubcriptionPlan.vue?vue&type=template&id=af229bea&"
import script from "./editSubcriptionPlan.vue?vue&type=script&lang=js&"
export * from "./editSubcriptionPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports